import { Cart } from '@commercetools/platform-sdk';

import { fromAxiosNutsJson, NutsJson, webstore } from '@/api';

export interface CreateCustomTrayResponse {
  cart?: Cart;
  cart_line?: {
    id: string;
    quantity_added: number;
  };
}

export async function addCustomTrayToCart(
  variantSku: string,
  variantContents: string[],
  options?: { asGift?: boolean; quantity?: number },
) {
  const formData = new FormData();
  formData.append('quantity', `${options?.quantity ?? 1}`);
  formData.append('tray-contents', variantContents.join(','));
  formData.append('size', variantSku);

  if (options?.asGift) {
    formData.append('marked_as_gift', '1');
  }

  const result = await fromAxiosNutsJson(
    webstore.post<NutsJson<CreateCustomTrayResponse>>('/custom-trays/create', formData),
    { onRedirect: () => {} },
  );

  return result;
}
